import { z } from 'zod';

import { ContractError } from '../../api';

export const mePayloadSchema = z
  .object({
    adminGrant: z.string().nullable().default(null),
    adminKeys: z.array(z.string()).default([]),
    plantIds: z.array(z.string()).default([]),
  })
  .passthrough();

export type MePayload = z.infer<typeof mePayloadSchema>;

export class AccessContractError extends ContractError {
  constructor(message: string, issues: unknown) {
    super(message, issues);
    this.name = 'AccessContractError';
  }
}

export const parseMe = (raw: unknown): MePayload => {
  const result = mePayloadSchema.safeParse(raw);
  if (!result.success) throw new AccessContractError('Invalid /v2/permissions/me payload', result.error.issues);
  return result.data;
};

const siteAccessEntrySchema = z.object({
  plantId: z.string(),
  canView: z.boolean(),
  canEditNotifications: z.boolean(),
  canEditPlant: z.boolean(),
  canManagePeople: z.boolean(),
});

const siteAccessPayloadSchema = z.object({ plants: z.array(siteAccessEntrySchema) });

export type SiteAccessPayload = z.infer<typeof siteAccessPayloadSchema>;

export const parseSiteAccess = (raw: unknown): SiteAccessPayload => {
  const result = siteAccessPayloadSchema.safeParse(raw);
  if (!result.success) throw new AccessContractError('Invalid /v2/permissions/site-access payload', result.error.issues);
  return result.data;
};
